// phpcs:ignoreFile
window.et_performance.loadingTime = {};

// send data to MP
et_performance.sendLoadingTimeToMP = function () {
	// prevent double sending to MP
	if (et_performance.already_sent_to_mp) {
		return;
	}
	et_performance.already_sent_to_mp = true;

	let counter = setInterval(() => {
		if (window.mp) {
			const navigationEntries =
				window.performance.getEntriesByType("navigation");

			if (navigationEntries.length > 0) {
				const navigationEntry = navigationEntries[0];
				const fetchStart = navigationEntry.fetchStart;
				const requestStart = navigationEntry.requestStart;
				const responseEnd = navigationEntry.responseEnd;
				const domLoaded = navigationEntry.domContentLoadedEventEnd;
				const pageLoaded = navigationEntry.domComplete;

				if (domLoaded)
					et_performance.loadingTime.dom_loaded = parseInt(domLoaded);
				if (pageLoaded)
					et_performance.loadingTime.page_loaded = parseInt(pageLoaded);

				et_performance.loadingTime.connect_time = parseInt(
					requestStart - fetchStart
				);
				et_performance.loadingTime.response_time = parseInt(
					responseEnd - requestStart
				);
			} else {
				console.warn("No navigation entries available.");
			}

			window.mp.track("Website Performance", et_performance.loadingTime);
			et_write_log(et_performance.loadingTime);

			// remove setInterval
			clearInterval(counter);
		}
	}, 1000);
};

//get real time difference in seconds, rounded to 1 decimal place
et_performance.getMilisecondsDiff = function () {
	const milisecondsDiff = Math.abs(
		Math.round(et_performance.HTMLStartTime - Date.now())
	);
	return parseInt(milisecondsDiff);
};

//check loading status every 0.1 seconds
const checkLoadingTime = function () {
	let counter = setInterval(() => {
		// check Cookiebot loading time
		if (!et_performance.loadingTime.cmp_loaded && window.Cookiebot.consent) {
			et_performance.loadingTime.cmp_loaded = et_performance.getMilisecondsDiff();
		}

		// check Google tag Manager loading time
		if (!et_performance.loadingTime.gtm_loaded && isGtmLoaded()) {
			et_performance.loadingTime.gtm_loaded = et_performance.getMilisecondsDiff();
		}

		// check Pipa loading time
		if (
			!et_performance.loadingTime.pipa_loaded &&
			document.querySelector(".login_placeholder")
		) {
			et_performance.loadingTime.pipa_loaded = et_performance.getMilisecondsDiff();
		}

		// check if time of load is more than 5 seconds, if it`s more we stop setInterval and send report to MP
		if (et_performance.already_sent_to_mp
			|| (et_performance.loadingTime.cmp_loaded
				&& et_performance.loadingTime.gtm_loaded
				&& et_performance.loadingTime.pipa_loaded
			)
		) {
			clearInterval(counter);
		}
	}, 100);
};

function isGtmLoaded() {
	let gtmStartedEvent = window.dataLayer.find(
		(element) => element["gtm.start"]
	);
	if (!gtmStartedEvent) {
		return false; // Not even the GTM inline config has executed
	} else if (!gtmStartedEvent["gtm.uniqueEventId"]) {
		return false; // GTM inline config has ran, but main GTM js is not loaded (likely AdBlock, NoScript, URL blocking etc.)
	}
	return true; // GTM is fully loaded and working
}

// Set the percentage threshold (10%)
// for test can use 1, then function will work on every load of page
et_performance.randomValue = Math.random(); // Generate a random number between 0 and 1
et_performance.percentageThreshold = 0.1;

// Run function for the 10% of visitors
if (et_performance.randomValue <= et_performance.percentageThreshold) {
	checkLoadingTime();
	window.addEventListener("load", function () {
		setTimeout(et_performance.sendLoadingTimeToMP, 5000);
	});
	// sometimes, the load event is not triggered, so this is the fallback after 30 seconds
	setTimeout(et_performance.sendLoadingTimeToMP, 30000);
}